import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    console.warn("Stimulus controller connected: hello-world");
  }
}
